/*
 * @Author: Dong
 * @Date: 2022-05-05 16:25:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-11 15:28:46
 */
import React, { useMemo, useState, useEffect } from 'react';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useLocation } from 'react-router-dom';
import { Layout, Message, Popover } from 'sup-ui';
import { menuRoutes } from 'root/routers';
import { useDispatch } from 'react-redux';
import { envManage } from 'root/pages/EnvManage/store/actions';
import styles from './Header.less';
import { useIntl } from 'react-intl';
import Icon from 'root/components/Icon';
import messages from './messages';
import Modal from 'root/components/CommonModal';
import { Form, Input } from 'sup-ui';
import { getInstanceName, updateInstanceName } from 'root/services/manager';

const { Header } = Layout;

interface FCFormProps extends FormComponentProps {
  runtimeEnvId: string;
}

const LayoutHeader = (props: FCFormProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { form } = props;
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [dataInfo, setDataInfo] = useState<any>({});
  const sessionData = sessionStorage.getItem('envStatus');
  const enableMultiInstance = sessionStorage.getItem('enableMultiInstance');
  const envInfo = sessionData ? JSON.parse(sessionData) : {};
  const user = localStorage.getItem('account') || '';

  const { getFieldDecorator } = form;

  const title = useMemo(() => {
    const path = pathname.substring(1);
    const { title } = menuRoutes[0].children?.find((item) => item.path === path) || {};
    return typeof title === 'object' ? intl.formatMessage(title) : title;
  }, [pathname]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!envInfo.runtimeEnvId) return;
    getData();
  }, [envInfo.runtimeEnvId]);

  const getData = () => {
    getInstanceName({ user }).then((res) => {
      if (!res.data) return;
      const { opsPort, opsIp, firstLogin } = res.data;

      setDataInfo(res.data);
      dispatch(
        envManage.changeEnvStatus({
          opsIp,
          opsPort,
          initPassword: firstLogin,
        }),
      );
    });
  };

  const onOk = () => {
    form.validateFields((err, values) => {
      if (err) return;
      updateInstanceName({ ...values }).then(() => {
        Message.success(intl.formatMessage(messages.successTip));
        getData();
      });

      toggleVisable();
    });
  };
  const toggleVisable = () => {
    setVisible(!visible);
    if (!visible) {
      form.resetFields();
    }
  };

  return (
    <Header className={styles.header}>
      <span>
        {location.hash === '#/instances' ? (
          <>
            {enableMultiInstance && (
              <span
                onClick={() => {
                  window.hashHistory.push('/envManage');
                }}
                className={styles.goBack}
              >
                {intl.formatMessage(messages.goback)}
              </span>
            )}
            <span> {dataInfo?.envName || intl.formatMessage(messages.defaultName)}</span>
            <span onClick={toggleVisable}>
              <Icon type="edits" className={styles.editsIcon} />
            </span>
          </>
        ) : (
          <span> {title}</span>
        )}
      </span>

      <Popover content={dataInfo.opsVersion} trigger="click" placement="bottomRight">
        <span className={styles.verison}>
          {intl.formatMessage(messages.verison)}
          {dataInfo.version}
        </span>
      </Popover>
      <Modal
        title={intl.formatMessage(messages.operatingEnv)}
        visible={visible}
        onOk={onOk}
        onCancel={toggleVisable}
        className={styles.modal}
        height="auto"
        width="556px"
      >
        <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          <div className={styles.flex}>
            <Form.Item label={intl.formatMessage(messages.operatingEnvName)}>
              {getFieldDecorator('name', {
                initialValue: dataInfo?.envName,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.operatingEnvNull),
                  },
                  {
                    message: intl.formatMessage(messages.nameError),
                    pattern: new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9]+$/),
                  },
                ],
              })(<Input maxLength={32} style={{ width: '300px' }} />)}
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </Header>
  );
};

export default Form.create()(LayoutHeader);
